// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "ebf1a36a9bc6be6efcbe" + "/js/" + chunkId + ".js";
};